import { User, RoleScopeType } from 'auth/dist/contexts/auth_context';

export enum Permission {
  ProgramsView = 'program_view',
  ProgramCreate = 'program_create',
  ProgramsUpdate = 'program_update',
  MembersView = 'member_view',
  MembersUpdate = 'member_update',
  StaffView = 'staff_view',
  StaffUpdate = 'staff_update',
  StaffDelete = 'staff_delete',
  MessagesView = 'message_view',
  OrgView = 'org_view',
  OrgFinancialView = 'org_financial_view',
  OrgUpdate = 'org_update',
  OrgCalendarView = 'org_calendar_view',
  PaymentAccountCreate = 'payment_account_create',
  CoordinatedDivisionsView = 'coordinated_divisions_view',
  SeasonDivisionsView = 'season_division_view',
  SeasonInvoicingView = 'season_invoicing_view',
  SeasonFinancialsView = 'season_financials_view',
  SeasonMemberView = 'season_members_view',
  SeasonRegistrationView = 'season_registration_view',
  SeasonScheduleView = 'season_schedule_view',
  SeasonSafetyView = 'season_safety_view',
  SeasonMessagesView = 'season_messages_view',
  SeasonSettingsView = 'season_settings_view',
  SeasonUpdate = 'season_update',
  SeasonDelete = 'season_delete',
}

export function hasPermissionForOrg(user: Partial<User>, permission, orgId) {
  // program roles also get some access to org level
  const orgRoles: any[] = user?.roles?.filter((role) => +role.organizationId === +orgId) || [];

  return orgRoles.some((role) => role.permissions.includes(permission));
}

export function hasPermissionForProgram(user: Partial<User>, permission: Permission, orgId: string, programId: string) {
  const programRoles =
    user?.roles.filter(
      (role) =>
        (role.scopeType === RoleScopeType.Organization && role.scopeId === orgId) || //orgid
        (role.scopeType === RoleScopeType.Program && role.scopeId === programId)
    ) || [];

  return programRoles.some((role) => role.permissions.includes(permission));
}
